import { Component } from '@angular/core';

@Component({
    selector: 'app-resource',
    templateUrl: './resource.component.html',
    styleUrls: ['./resource.component.scss']
})
export class ResourceComponent {
    public logos: Array<{ [property: string]: string; background: 'true' | 'false' }> = [
        {
            title: 'logo_file_one',
            url_image: 'assets/images/press/logos/logo-saldo-original.svg',
            url_download_images_png: 'assets/images/press/logos/logo-saldo-original.png',
            url_download_images_svg: 'assets/images/press/logos/logo-saldo-original.svg',
            background: 'false'
        },
        {
            title: 'logo_file_two',
            url_image: 'assets/images/press/logos/logo-saldo-white.svg',
            url_download_images_png: 'assets/images/press/logos/logo-saldo-white.png',
            url_download_images_svg: 'assets/images/press/logos/logo-saldo-white.svg',
            background: 'true'
        }
    ];
}
